const routes = [
  {
    path: '/',
    // Relative to /src/views
    //view: 'Home',
    name: 'Inicio',
    component: () => import('@/views/App'),
    meta: {
      logged: false,
      superior: true,
      icon: 'mdi-home-outline'
    },
    children: [
      {
        path: '',
        name: 'Inicio',
        component: () => import('@/views/HomeRene'),
        meta: {
          logged: false,
          superior: true,
          icon: 'mdi-information-outline'
        }
      },
      /*{
        path: '/inicio-sesion',
        name: 'Inicio Sesión',
        view: 'Login',
        meta:{
          onlyAnonimous: true,
          logged: false,
          superior: true
        }
      },*/
      {
        path: 'tu-cuenta/pedidos',
        name: 'Tus pedidos',
        component: () => import('@/views/TuCuenta/Pedidos'),
        meta: {
          logged: true,
          tucuenta: false,
          icon: 'mdi-basket'
        }
      },
      {
        path: '/tu-cuenta/favoritos',
        name: 'Favoritos',
        component: () => import('@/views/TuCuenta/Favoritos'),
        meta: {
          logged: true,
          tucuenta: false,
          icon: 'mdi-cards-heart'
        }
      },
      {
        path: '/tu-cuenta/direcciones',
        name: 'Direcciones',
        component: () => import('@/views/TuCuenta/Direcciones'),
        meta: {
          logged: true,
          tucuenta: false,
          icon: 'mdi-map-marker'
        }
      },
      {
        path: '/tu-cuenta/formaspago',
        name: 'Formas de Pago',
        component: () => import('@/views/TuCuenta/FormasPago'),
        meta: {
          logged: true,
          tucuenta: true,
          icon: 'mdi-cards'
        }
      },
      {
        path: '/tu-cuenta/perfil',
        name: 'Perfil',
        component: () => import('@/views/Perfil'),
        meta: {
          logged: true,
          tucuenta: true,
          icon: 'mdi-account'
        }
      },
      //PEDIDOS
      {
        path: 'pedir',
        name: 'Elige Modo',
        component: () => import('@/views/Pedidos/ElegirModo'),
        meta: {
          logged: false,
          superior: false,
          icon: 'mdi-noodles'
        }
      },
      {
        path: '/pedir/domicilio',
        name: 'Busca tu restaurante',
        component: () => import('@/views/Pedidos/Domicilio'),
        meta: {
          logged: false,
          superior: true,
          icon: 'mdi-map-search'
        }
      },
      {
        path: '/pedir/recoger',
        name: 'Para recoger',
        component: () => import('@/views/Pedidos/Recoger'),
        meta: {
          logged: false,
          superior: true,
          icon: 'mdi-food-fork-drink'
        }
      },
      {
        path: '/pedir/verificacion',
        name: 'Verificación',
        component: () => import('@/views/Pedidos/Verificar'),
        meta: {
        }
      },
      {
        path: '/pedir/:modo/:negocio/:rest/',
        name: 'Pedidos',
        component: () => import('@/views/Pedidos/Pedir'),
        meta: {

        }
      },
      {
        path: '/pedir/finalizar',
        name: 'Finaliza tu pedido',
        component: () => import('@/views/Pedidos/Finalizar'),
        meta: {
        }
      },
      {
        path: '/pedir/resumen-pedido',
        name: 'Resumen de tu pedido',
        component: () => import('@/views/Pedidos/resumenPedido'),
        meta: {
        }
      },
      {
        path: '/pedir/finalizar-pedido-rene',
        name: 'Finalizar pedido Rene',
        component: () => import('@/views/Pedidos/FinalizarRene'),
        meta: {
        }
      }
    ]
  },
  {
    path: 'terminos-y-condiciones-de-uso',
    name: 'Términos y condiciones de uso',
    component: () => import('@/views/terminosYCondiciones.vue'),
    meta: {
      logged: false,
      tucuenta: false,
      icon: 'mdi-basket'
    },
  }
]

export { routes }